
export default {
  whiteOrgs: [],
  chnl: 0,
  total:0,
  max:10,
  offset:0,
  sort: 'organization.name',
  order: 'ascending'
};
